
































































































































import Vue from 'vue';

import { upload, uploadVimeoThumbnail } from '@/web/services/upload';
import mediaApi from '@/core/api/modules/media-libraries';
import { errorToMessage } from '@/core/utils/errors';
import MediaThumbnail from '@/web/components/products/MediaThumbnail.vue';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import { HMUpgradePlanModal } from '@/web/components/common/index';

enum thumbnailType {
  cover = 'cover',
  contain = 'contain',
  profile = 'profile',
}

export default Vue.extend({
  name: 'HMFileUpload',
  components: {
    MediaThumbnail,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    inputName: {
      type: String,
      default: 'upload-file',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    fileDescription: {
      type: String,
      default: '',
    },
    thumbnailType: {
      type: String as () => thumbnailType,
      default: thumbnailType.cover,
    },
    changeVimeoThumbnailEnabled: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default:
        'image/*,audio/*,video/*,application/pdf,application/msword,application/vnd.ms-excel,application/vnd.ms-powerpoint,text/plain,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    },
    studioURL: {
      type: String,
      default: null,
    },
    videoUploadAllowed: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      inputValue: null,
      error: null,
      isUploading: false,
      progress: 0,
      isDragging: false,
      updatingVimeoThumbnail: false,
    };
  },
  computed: {
    status() {
      if (this.isDragging) {
        return 'dragging';
      } else if (this.isUploading) {
        return 'uploading';
      } else if (this.value) {
        return 'uploaded';
      } else {
        return 'add';
      }
    },
    acceptedFiles() {
      // if we want to remove the video upload option we should use this instead of the accept in <input> above
      if (!this.videoUploadAllowed) {
        return this.accept
          .split(',')
          .filter(e => e !== 'video/*')
          .join(',');
      }
      return this.accept;
    },
    thumbnailSrc() {
      if (!this.value) return;
      const { embedded_thumbnail_url, thumbnail } = this.value;
      return embedded_thumbnail_url || thumbnail;
    },
    mediaType() {
      return this.value?.file_content;
    },
  },
  methods: {
    isValidFile(inputFile) {
      if (this.accept === '*') return true;
      if (this.accept.includes(`${inputFile.type.split('/')[0]}/*`))
        return true;
      if (this.accept.includes(`${inputFile.type}`)) return true;

      return false;
    },
    async upload(inputFile) {
      if (!inputFile) return;
      if (!this.isValidFile(inputFile)) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'File type not supported',
        });
        return;
      }
      this.isUploading = true;
      this.$emit('uploading', true);
      try {
        const { type } = inputFile;
        if (type.includes('video') && !this.videoUploadAllowed) {
          this.$modal.show(HMUpgradePlanModal, {
            description: 'GENERAL.TEXT.UPGRADE_VIDEO_UPLOAD',
            onConfirm: () => {
              this.$modal.hideAll();
              this.$router.push({ name: 'settings-adjust-plan' });
            },
          });
          return;
        }
        const file = await upload(
          inputFile,
          progress => (this.progress = progress),
          this.studioURL
        );
        this.updateFile(file);
        return file;
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response, `File upload: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.isUploading = false;
        this.$emit('uploading', false);
      }
    },
    onChange(e) {
      const file = e.target.files[0];
      this.$refs.inputFile.value = null;
      this.upload(file);
    },
    drop: function (event) {
      event.stopPropagation();
      event.preventDefault();
      this.isDragging = false;
      const file = event.dataTransfer.files[0];
      this.upload(file);
    },
    updateFile(file) {
      this.$emit('input', file);
    },
    dragging() {
      this.isDragging = true;
    },
    draggingStop() {
      this.isDragging = false;
    },
    async remove() {
      this.isUploading = true;
      const file = null;
      this.$emit('input', file);
      this.isUploading = false;
    },
    async onVimeoThumbnailChange(e) {
      this.updatingVimeoThumbnail = true;
      const file = e.target.files[0];
      console.log(file);
      this.$refs.vimeoThumbnailInputFile.value = null;
      const vimeoVideoId = this.value?.video_url.split('/').pop();
      if (!vimeoVideoId) return;
      const mediaFile = await uploadVimeoThumbnail(
        this.value.id,
        vimeoVideoId,
        file
      );
      this.updateFile(mediaFile);
      this.$notify({
        group: 'app',
        type: 'success',
        title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
        text: this.$t('NOTIFICATIONS.TEXT.THUMBNAIL_SUCCESSFULLY_UPDATED'),
      });

      this.updatingVimeoThumbnail = false;
    },
  },
});
